<template>
  <div>
    <div class="is-clearfix">
      <nav class="breadcrumb" aria-label="breadcrumbs">
        <ul>
          <li>
            <nuxt-link :to="localePath('office-products')">
              {{
              $t("page.products")
              }}
            </nuxt-link>
          </li>
          <li>
            <nuxt-link :to="localePath('office-products-glass')">
              {{
              $t("page.glass")
              }}
            </nuxt-link>
          </li>

          <li class="is-active">
            <a aria-current="page">{{ $t('page.inner_cutout')}}</a>
          </li>
        </ul>
      </nav>
    </div>

    <div class="table-wrapper" ref="tableWrapper">
      <table
        class="table m-t-5 is-striped is-fullwidth"
        ref="table"
        v-if="$store.getters['options/inner_cutout'].length"
      >
        <thead>
          <tr>
            <th>{{ $t("form.name") }}</th>
            <th>{{ $t("form.type") }}</th>
            <th>{{ $t("form.code") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="hd in $store.getters['options/inner_cutout']" :key="hd.id">
            <td>{{ hd.name }}</td>
            <td>{{ hd.type }}</td>
            <td>{{ hd.code }}</td>
          </tr>
        </tbody>
      </table>
      <div v-else class="m-t-6">{{$t('message.no_data')}}</div>
    </div>
    <span
      v-if="showSwipeIcon"
      class="mdi mdi-gesture-swipe-horizontal has-text-primary"
      style="font-size: 25px"
    ></span>
  </div>
</template>

<script>
export default {
  computed: {
    showSwipeIcon() {
      return (
        this.isMounted &&
        this.$refs.table &&
        this.$refs.table.scrollWidth > this.$refs.tableWrapper.clientWidth
      );
    }
  },
};
</script>




// WEBPACK FOOTER //
// resources/nuxt/pages/office/products/glass/inner-cutout/index.vue